import React from "react";
import { FooterProps } from "./FooterBar.types";
import {
  StyledFooter,
  StyledLandingFooter,
  StyledDetailFooter,
  StyledFooterContent,
  StyledFeedbackLink,
} from "./FooterBar-styled";
import ShareButton from "../ShareButton";
import TranslationSelectGoogle from "../TranslationSelectGoogle/TranslationSelectGoogle";

import { useTranslation, I18nextProvider } from "react-i18next";
import instance from "../../utils/i18n";

import TranslationSelectI18n from "../TranslationSelectI18n";

const feedbackUrl = "https://www.nyc.gov/content/childcarehub/pages/website-feedback";

const FooterBar = ({
  footerType,
  onLocaleChange,
}: FooterProps) => {
  const { t, i18n } = useTranslation("components", { i18n: instance });
  const shareText =
    footerType === "details"
      ? "Copy and share link to provider"
      : t("share").toString();

  return (
    <I18nextProvider i18n={i18n}>
      <StyledFooter as={footerType === "landing" ? StyledLandingFooter : StyledDetailFooter}>
        <StyledFooterContent
          className={footerType === "details" ? "details-footer-content" : undefined}
        >
          {footerType === "landing" && !onLocaleChange && <TranslationSelectGoogle />}
          {footerType === "landing" && onLocaleChange && (
            <TranslationSelectI18n onChange={onLocaleChange} />
          )}
          <ShareButton
            shareUrl={window.location.href}
            shareText={shareText}
            variant={footerType === "details" ? "link" : "button"}
          />
          {footerType === "details" && (
            <StyledFeedbackLink href={feedbackUrl} target="_blank" rel="noreferrer">
              Report an issue
            </StyledFeedbackLink>
          )}
        </StyledFooterContent>
      </StyledFooter>
    </I18nextProvider>
  );
};

export default FooterBar;
